// extracted by mini-css-extract-plugin
export default {"container":"adc__container--YfG_0","duration-container":"adc__duration-container--lKBeK"};